import React from 'react';
import { AwardIcon, BookOpenIcon, UsersIcon, ArrowRightIcon } from 'lucide-react';
import { ScrollReveal } from './ScrollReveal';
import { Link } from 'react-router-dom';
export function AboutSection() {
  return <section id="akademie" className="py-24 bg-white" data-id="element-18">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-19">
        <ScrollReveal variant="up" data-id="element-20">
          <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-21">
            <h2 className="text-3xl md:text-5xl font-extrabold text-slate-700 mb-6 tracking-tight" data-id="element-22">
              Willkommen bei der 2N – Ihrem Fortbildungsinstitut in Nürnberg
            </h2>
            <p className="text-base sm:text-lg text-slate-500 leading-relaxed font-medium" data-id="element-23">
              Die Akademie für zahnärztliche Fortbildung ist Ihre Anlaufstelle,
              wenn Sie nach qualifizierter Weiterbildung und innovativen
              Kursformaten in der Zahnmedizin suchen. Unser Anspruch ist es,
              Zahnärzten, Oralchirurgen und Praxisteams praxisnahe,
              zertifizierte Weiterbildung zu ermöglichen.
            </p>
          </div>
        </ScrollReveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-16" data-id="element-24">
          <ScrollReveal variant="up" delay={100} data-id="element-25">
            <div className="bg-slate-50 p-10 rounded-3xl border border-slate-100 hover:shadow-xl transition-all duration-300 hover:-translate-y-2 group" data-id="element-26">
              <div className="w-16 h-16 bg-[#59d0d4]/15 rounded-2xl flex items-center justify-center mb-8 text-[#3b7780] group-hover:scale-110 transition-transform" data-id="element-27">
                <BookOpenIcon className="h-8 w-8" data-id="element-28" />
              </div>
              <h3 className="text-2xl font-extrabold text-slate-700 mb-4 tracking-tight" data-id="element-29">
                Praxisnahes Curriculum
              </h3>
              <p className="text-slate-500 font-medium leading-relaxed" data-id="element-30">
                Unser Herzstück ist das Curriculum Zahnmedizin, das aktuelle
                wissenschaftliche Erkenntnisse mit direkter Umsetzbarkeit im
                Praxisalltag verbindet.
              </p>
            </div>
          </ScrollReveal>

          <ScrollReveal variant="up" delay={200} data-id="element-31">
            <div className="bg-slate-50 p-10 rounded-3xl border border-slate-100 hover:shadow-xl transition-all duration-300 hover:-translate-y-2 group" data-id="element-32">
              <div className="w-16 h-16 bg-[#59d0d4]/15 rounded-2xl flex items-center justify-center mb-8 text-[#3b7780] group-hover:scale-110 transition-transform" data-id="element-33">
                <UsersIcon className="h-8 w-8" data-id="element-34" />
              </div>
              <h3 className="text-2xl font-extrabold text-slate-700 mb-4 tracking-tight" data-id="element-35">
                Für alle Erfahrungsstufen
              </h3>
              <p className="text-slate-500 font-medium leading-relaxed" data-id="element-36">
                Sie profitieren von einem modular aufgebauten Programm, das
                sowohl Einsteiger als auch erfahrene Kollegen gezielt fördert
                und weiterbringt.
              </p>
            </div>
          </ScrollReveal>

          <ScrollReveal variant="up" delay={300} data-id="element-37">
            <div className="bg-slate-50 p-10 rounded-3xl border border-slate-100 hover:shadow-xl transition-all duration-300 hover:-translate-y-2 group" data-id="element-38">
              <div className="w-16 h-16 bg-amber-100 rounded-2xl flex items-center justify-center mb-8 text-amber-600 group-hover:scale-110 transition-transform" data-id="element-39">
                <AwardIcon className="h-8 w-8" data-id="element-40" />
              </div>
              <h3 className="text-2xl font-extrabold text-slate-700 mb-4 tracking-tight" data-id="element-41">
                Anerkannte Fortbildungspunkte
              </h3>
              <p className="text-slate-500 font-medium leading-relaxed" data-id="element-42">
                Als anerkannte Akademie erhalten Sie bei jedem Kurs offiziell
                bescheinigte Fortbildungspunkte für Zahnärzte zur Erfüllung
                Ihrer Nachweispflichten.
              </p>
            </div>
          </ScrollReveal>
        </div>

        <ScrollReveal variant="up" delay={400} data-id="element-43">
          <div className="text-center mb-24" data-id="element-44">
            <Link to="/kontakt" className="inline-flex items-center justify-center px-8 py-4 text-lg font-bold rounded-md text-white bg-[#3b7780] hover:bg-[#2d5f66] transition-all hover:scale-105 shadow-lg" data-id="element-45">
              Jetzt Kursplan sichern
              <ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-46" />
            </Link>
          </div>
        </ScrollReveal>

        {/* Fortbildungspunkte Highlight Section */}
        <ScrollReveal variant="scale" data-id="element-47">
          <div className="bg-[#1a1a1a] rounded-[2rem] overflow-hidden shadow-2xl relative" data-id="element-48">
            <div className="grid grid-cols-1 lg:grid-cols-2" data-id="element-49">
              <div className="p-12 md:p-20 flex flex-col justify-center relative z-10" data-id="element-50">
                <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-amber-500/20 text-amber-400 text-sm font-extrabold uppercase tracking-wider mb-8 w-fit" data-id="element-51">
                  <AwardIcon className="h-5 w-5" data-id="element-52" />
                  Offizieller Nachweis
                </div>
                <h3 className="text-3xl md:text-4xl font-extrabold text-white mb-6 tracking-tight" data-id="element-53">
                  Fortbildungspunkte für Zahnärzte einfach sammeln
                </h3>
                <p className="text-[#748282] mb-6 leading-relaxed font-medium text-base sm:text-lg" data-id="element-54">
                  Unsere Programme sind von den Zahnärztekammern zertifiziert
                  und unterstützen Sie dabei, Ihre jährlichen Nachweispflichten
                  zuverlässig zu erfüllen. Nach erfolgreicher Teilnahme erhalten
                  Sie ein offizielles Zertifikat über die erreichten
                  Fortbildungspunkte.
                </p>
                <p className="text-[#59d0d4] font-bold text-base sm:text-lg" data-id="element-55">
                  So verbinden Sie nachhaltiges Lernen mit optimaler Compliance.
                </p>
              </div>
              <div className="relative h-80 lg:h-auto overflow-hidden" data-id="element-56">
                <ScrollReveal variant="clip" className="absolute inset-0 w-full h-full" data-id="element-57">
                  <img src="https://cdn.rawproductionsgmbh.de/2n/home/header.jpg" alt="Zahnärztliche Fortbildung Praxis" className="absolute inset-0 w-full h-full object-cover hover:scale-105 transition-transform duration-1000" data-id="element-58" />
                  <div className="absolute inset-0 bg-gradient-to-r from-[#1a1a1a] to-transparent lg:w-1/2" data-id="element-59"></div>
                </ScrollReveal>
              </div>
            </div>
          </div>
        </ScrollReveal>
      </div>
    </section>;
}